'use strict';

const crypto = require('crypto');
let nodeForge;
try {
    nodeForge = require('node-forge');
} catch (err) {
    // istanbul ignore if: impossible to test with proxyquire
    if (err.code !== 'MODULE_NOT_FOUND') {
        throw err;
    }
}

const DATA_URI_PATTERN = /^data:application\/pkcs8;kid=([\w.\-+/]+);base64,([a-zA-Z0-9+/=]+)$/;

function parsePrivateKeyWithNodeForge(privateKeyDerBase64) {
    const privateKeyDerBuffer = nodeForge.util.decode64(privateKeyDerBase64);
    const privateKeyAsn1 = nodeForge.asn1.fromDer(privateKeyDerBuffer);
    const privateKeyObj = nodeForge.pki.privateKeyFromAsn1(privateKeyAsn1);
    const privateKeyPem = nodeForge.pki.privateKeyToPem(privateKeyObj);
    return privateKeyPem.toString('base64');
}

// Note: This can't be tested on node<11, so in CI we don't enforce full coverage on node<11 because of this.
function parsePrivateKeyWithCrypto(privateKeyDerBase64) {
    const privateKeyDerBuffer = Buffer.from(privateKeyDerBase64, 'base64');
    const privateKeyObj = crypto.createPrivateKey({
        key: privateKeyDerBuffer,
        type: 'pkcs8',
        format: 'der'
    });
    const privateKeyPemBuffer = privateKeyObj.export({type: 'pkcs8', format: 'pem'});
    return privateKeyPemBuffer.toString('base64');
}

function parsePrivateKey(privateKeyDerBase64) {
    if (crypto.createPrivateKey) {
        return parsePrivateKeyWithCrypto(privateKeyDerBase64);
    } else if (nodeForge) {
        return parsePrivateKeyWithNodeForge(privateKeyDerBase64);
    } else {
        throw new Error(
            'node-forge must be installed for Node.js versions older than v11.6.0. ' +
                'Please install node-forge (npm install --save node-forge) or upgrade to a newer version of Node.js.'
        );
    }
}

function parseDataUri(dataUri) {
    const match = DATA_URI_PATTERN.exec(decodeURIComponent(dataUri));
    if (!match) {
        throw new Error('Data URI does not match required format!');
    }

    const keyId = match[1];
    const privateKey = parsePrivateKey(match[2]);

    return {
        keyId,
        privateKey
    };
}

module.exports = parseDataUri;
